module.exports = __webpack_public_path__ + "img/泰航登录企业.66537346.png";